export const common = {
  nav: {
    service: 'Service',
    ablauf: 'Ablauf',
    process: 'Ablauf',
    buchen: 'Buchen',
    book: 'Buchen',
    jetztBuchen: 'Jetzt Buchen',
    bookNow: 'Jetzt Buchen',
    menuOpen: 'Menü öffnen',
    subtitle: 'SKI-SERVICE KURIER',
  },

  hero: {
    badge: 'bis {{orderDeadline}} bestellen • {{returnTime}} Rückgabe',
    skiServiceKurier: 'SKI-SERVICE KURIER',
    subtitle: 'SKI-SERVICE KURIER',
    headline1: 'SKI ABHOLEN LASSEN',
    headline2: 'SERVICE ÜBER NACHT',
    headline3: 'MORGENS BIS {{returnTime}} ZURÜCK',
    cardTitle: 'BEQUEM UND EINFACH VON ZUHAUSE AUS',
    cardSubtitle: 'PERFEKT PRÄPARIERTE SKI',
    cardDescription: 'Wir holen deine Ski am Abend ab, führen einen professionellen Service durch und bringen sie am nächsten Morgen bis spätestens {{returnTime}} Uhr perfekt präpariert zurück. So startest du wieder sicher und griffig in deinen Skitag.',
    ctaButton: 'JETZT BUCHEN',
    availableIn: 'Verfügbar in:',
    location1: '7247 Saas',
    location2: '7249 Serneus',
    location3: '7250 Klosters',
    inCollabWith: 'In Zusammenarbeit mit',
  },

  howItWorks: {
    title: 'Vier einfache Schritte zu perfekt präparierten Ski',
    titleMobile: 'Vier einfache Schritte',
    stepLabel: 'SCHRITT',
    step1: {
      title: 'Service bestellen bis {{orderDeadline}}',
      titleMobile: 'Bestellen bis {{orderDeadline}}',
      description: 'Bestelle deinen Ski-Service bequem online – einfach bis spätestens {{orderDeadline}} am gewünschten Abend.',
      descriptionMobile: 'Bequem online bestellen – bis {{orderDeadline}} Uhr.',
    },
    step2: {
      title: 'Abholung am Abend vor der Haustüre',
      titleMobile: 'Abholung am Abend',
      description: 'Am Abend holen wir deine Ski bequem direkt vor deiner Unterkunft ab. Schnell, bequem und zuverlässig.',
      descriptionMobile: 'Wir holen deine Ski direkt vor der Unterkunft ab.',
    },
    step3: {
      title: 'Profi-Service & Qualitätskontrolle',
      titleMobile: 'Profi-Service über Nacht',
      description: 'Unsere Experten schleifen, wachsen und reparieren deine Ski mit modernster Technik. Jedes Paar durchläuft anschliessend eine finale Qualitätsprüfung.',
      descriptionMobile: 'Schleifen, wachsen, reparieren – mit finaler Qualitätsprüfung.',
    },
    step4: {
      title: 'Rückgabe bis {{returnTime}}',
      titleMobile: 'Rückgabe bis {{returnTime}}',
      description: 'Pünktlich bis {{returnTime}} Uhr bringen wir deine Ski zurück. Perfekt vorbereitet für den ersten Lift.',
      descriptionMobile: 'Bis {{returnTime}} Uhr zurück – bereit für den ersten Lift.',
    },
  },

  services: {
    sectionLabel: 'UNSERE LEISTUNGEN',
    sectionTitle: 'WÄHLE DEINEN SERVICE',
    discount: 'Einführungsrabatt',
    bookButton: 'BUCHEN',
    mobileBookButton: 'BUCHEN',
    modalBookButton: 'JETZT BUCHEN',
    modalFeaturesLabel: 'Leistungen',
    juniorLengthNote: 'Nur für Skis bis 1,5 m Länge',
    junior: {
      title: 'JUNIOR-SERVICE',
      description: 'Gleicher Profi-Service wie der Standard – speziell für Kinderskis bis 1,5 m Länge.',
      feature1: 'Belag schleifen',
      feature2: 'Kanten schleifen seitlich',
      feature3: 'Kanten schleifen hängend',
      feature4: 'Wachsen',
      feature5: 'Polieren',
      feature6: 'Nur für Skis bis 1,5 m Länge',
      mobileFeature1: 'Belag schleifen',
      mobileFeature2: 'Kanten schleifen',
      mobileFeature3: 'Wachsen & polieren',
    },
    kleiner: {
      title: 'STANDARD-SERVICE',
      description: 'Kanten professionell schleifen, Belag wachsen und Strukturschliff wiederherstellen.',
      feature1: 'Belag schleifen',
      feature2: 'Kanten schleifen seitlich',
      feature3: 'Kanten schleifen hängend',
      feature4: 'Wachsen',
      feature5: 'Polieren',
      mobileFeature1: 'Belag schleifen',
      mobileFeature2: 'Kanten schleifen',
      mobileFeature3: 'Belag wachsen & polieren',
    },
    grosser: {
      title: 'PRO-SERVICE',
      description: 'Vollständiger Service mit Belagsaufguss, Schleifen, Kanten und Wachsen für optimale Performance.',
      feature1: 'Belag aufgiessen und sämtliche grosse und kleine Dellen auffüllen',
      feature2: 'Belag vorschleifen',
      feature3: 'Belag feinschleifen',
      feature4: 'Kanten schleifen seitlich',
      feature5: 'Kanten schleifen hängend',
      feature6: 'Wachsen',
      feature7: 'Polieren',
      mobileFeature1: 'Belag reparieren',
      mobileFeature2: 'Belag schleifen',
      mobileFeature3: 'Kanten schleifen',
      mobileFeature4: 'Belag wachsen & polieren',
    },
    renn: {
      title: 'RENN-SERVICE',
      description: 'Kompletter Renn-Service inkl. Rennwachs für deine Top-Performance.',
      feature1: 'Belag aufgiessen und sämtliche grosse und kleine Dellen auffüllen',
      feature2: 'Belag vorschleifen',
      feature3: 'Belag feinschleifen',
      feature4: 'Kanten schleifen seitlich',
      feature5: 'Kanten schleifen hängend',
      feature6: 'Wachs-Tiefenbehandlung',
      feature7: 'Polieren',
      feature8: 'Rennwachs-Finish auftragen',
      mobileFeature1: 'Belag reparieren & schleifen',
      mobileFeature2: 'Kanten schleifen',
      mobileFeature3: 'Wachs-Tiefenbehandlung & Belag polieren',
      mobileFeature4: 'Rennwachs-Finish',
    },
  },

  pricing: {
    sectionTitle: 'WÄHLE DEINEN SERVICE',
    sectionSubtitle: 'Professionelle Qualität. Alle Preise pro Ski-Paar.',
    badgeKids: 'KIDS',
    badgePopular: 'BELIEBT',
    badgePremium: 'PREMIUM',
    badgeRecommended: 'EMPFOHLEN',
    discount: 'Einführungsrabatt',
    perPair: '/Paar',
    bookButton: 'BUCHEN',
    detailsShow: 'Details',
    detailsHide: 'Weniger',
    scrollHint: '← Wische für mehr Optionen →',
    juniorLengthNote: 'Nur für Skis bis 1,5 m Länge',
    mobileBookButton: 'BUCHEN',
    pickupIncluded: 'Abholen bei dir Zuhause und Retournieren am nächsten Morgen',
  },

  trustBar: {
    label: 'Qualitätsversprechen',
    headline: 'Nicht zufrieden? Wir machen den Service kostenlos nochmals.',
    subtext: 'Unsere Qualitätsgarantie – ohne Wenn und Aber.',
    watermark: 'GARANTIE',
    item1Title: 'Lokales Fachpersonal mit jahrelanger Erfahrung',
    item1Desc: 'Unsere Experten in unserer Partnerwerkstatt in Klosters kennen Ski und Schnee – Service auf höchstem Niveau.',
    item2Title: 'Fotodokumentation bei jeder Übergabe',
    item2Desc: 'Wir dokumentieren den Zustand deiner Ski bei Abholung und Rückgabe – transparent und nachvollziehbar.',
    item3Title: 'Volle Haftung bei Schäden',
    item3Desc: 'Sollte an deinen Ski während Abholung, Service oder Rückgabe doch einmal ein Schaden entstehen, kommen wir vollumfänglich dafür auf.',
    workshopLabel: 'Partnerwerkstatt in Klosters',
  },

  booking: {
    title: 'BUCHE DEINEN SERVICE',
    stepService: 'Service',
    stepAddress: 'Adresse',
    stepPayment: 'Zahlung',
    stepAddressTitle: 'Adressangaben',
    positionLabel: 'Position {{n}}',
    pairsLabel: 'Anzahl Paare',
    addServiceButton: 'Weiteren Service hinzufügen',
    alreadySelected: '(bereits gewählt)',
    plzSelectLabel: 'PLZ & Ort wählen',
    toAddressButton: 'zur Adressangabe',
    toPaymentButton: 'zur Zahlung',
    errorServiceRequired: 'Bitte mindestens einen Service hinzufügen',
    errorDateRequired: 'Bitte Abholdatum wählen',
    errorReturnDateRequired: 'Bitte Rückgabedatum wählen',
    errorPickupRequired: 'Bitte Abholort wählen',
    pairCount_one: '{{count}} Paar',
    pairCount_other: '{{count}} Paare',
    serviceCount_one: '{{count}} Service',
    serviceCount_other: '{{count}} Services',
    labelName: 'Name',
    placeholderName: 'Dein vollständiger Name',
    labelAddress: 'Unterkunft / Adresse',
    placeholderAddress: 'z. B. Landstrasse 12, 7250 Klosters',
    labelCareOf: 'c/o – Name an der Türklingel / Hotel',
    placeholderCareOf: 'z. B. Familie Müller, Hotel Alpina, Chalet Alpenblick',
    careOfOptional: 'optional',
    careOfHint: 'Falls dein Name nicht an der Klingel steht – gib hier den Namen an, der dort steht (Eigentümer, Hotel o. Ä.).',
    addressValidating: 'Adresse wird überprüft...',
    addressConfirmed: 'Adresse gefunden und bestätigt.',
    addressHint: 'Erlaubte PLZ: 7247 (Saas), 7249 (Serneus), 7250 (Klosters), 7252 (Klosters-Dorf)',
    errorInvalidPLZ: 'Bitte gib eine gültige PLZ an: 7247, 7249, 7250 oder 7252.',
    errorAddressNotFound: 'Diese Adresse konnte nicht gefunden werden. Bitte überprüfe die Eingabe (z. B. Strasse, Hausnummer und PLZ).',
    labelPhone: 'Telefon',
    placeholderPhone: '+41 XX XXX XX XX',
    labelEmail: 'E-Mail',
    placeholderEmail: 'deine@email.ch',
    labelService: 'Service-Auswahl',
    serviceJunior: 'JUNIOR-SERVICE',
    serviceKleiner: 'STANDARD-SERVICE',
    serviceGrosser: 'PRO-SERVICE',
    serviceRenn: 'RENN-SERVICE',
    optionJunior: 'JUNIOR-SERVICE - 29 CHF (Kanten schleifen, Belag wachsen, Strukturschliff – bis 1,5 m)',
    optionKleiner: 'STANDARD-SERVICE - 49 CHF (Kanten schleifen, Belag wachsen, Strukturschliff)',
    optionGrosser: 'PRO-SERVICE - 69 CHF (Belagsausbesserung, Strukturschliff, Kanten schleifen, Wachs-Tiefenbehandlung)',
    optionRenn: 'RENN-SERVICE - 79 CHF (Wachs-Tiefenbehandlung, Rennwachs-Finish, Kanten schleifen, Belagsausbesserungen)',
    labelPickupDate: 'Abholdatum',
    pickupDateHint: '(Bestellung bis spätestens {{orderDeadline}})',
    labelReturnDate: 'Retour am',
    returnDateHint: '(spätestens zurück um {{returnTime}})',
    labelPairs: 'Anzahl Ski-Paare',
    pairLabel_one: 'Paar',
    pairLabel_other: 'Paare',
    labelPickupLocation: 'Wo können wir deine Ski abholen?',
    pickupDoor: 'Vor der Haustüre',
    pickupRing: 'Bitte klingeln',
    pickupReception: 'Bitte bei der Reception nachfragen',
    pickupCall: 'Bitte anrufen bei Abholung',
    submitButton: 'ZUR BUCHUNGSÜBERSICHT',
    submitting: 'WIRD GESENDET...',
    validatingAddress: 'ADRESSE WIRD GEPRÜFT...',
    errorSubmit: 'Es gab ein Problem beim Senden. Bitte versuche es erneut.',
    footerNote: 'Service bestellen bis {{orderDeadline}} Uhr • Rückgabe bis {{returnTime}} Uhr',
    marketingConsentLabel: 'Ich möchte per E-Mail über Aktionen, Rabatte und Neuigkeiten von Ski-Service Kurier informiert werden. Die Einwilligung kann jederzeit widerrufen werden.',
    marketingConsentShort: 'Newsletter',
  },

  payment: {
    title: 'BEZAHLUNG',
    summaryTitle: 'Buchungsübersicht',
    pickupLabel: 'Abholung',
    pickupTime: 'bis {{deliveryTime}} Uhr',
    returnLabel: 'Rückgabe',
    returnTime: 'bis {{returnTime}} Uhr',
    locationLabel: 'Abholort',
    totalLabel: 'TOTAL',
    methodTitle: 'Zahlungsmethode wählen',
    methodCredit: 'Kreditkarte',
    methodPaypal: 'PayPal',
    methodApple: 'Apple Pay',
    methodTwint: 'TWINT',
    payButton: 'BEZAHLEN {{amount}} CHF',
    processing: 'WIRD VERARBEITET...',
    secureNote: 'Sichere Zahlung – Deine Daten sind verschlüsselt',
    successTitle: '🎿 Danke für deine Buchung!',
    successMessage1: 'Deine Buchung ist bestätigt. Eine Bestätigungs-E-Mail wurde an deine Adresse gesendet.',
    successMessage2: 'Wir holen deine Ski am vereinbarten Abend ab und bringen sie bis {{returnTime}} Uhr perfekt präpariert zurück.',
    successMessage3: 'Bitte stelle sicher, dass deine Ski bis {{skiReadyTime}} Uhr am gewählten Standort bereitstehen.',
    successButton: 'OK',
    pairLabel_one: 'Paar',
    pairLabel_other: 'Paare',
    initializing: 'Zahlung wird vorbereitet...',
    errorTitle: 'Fehler beim Laden',
    errorInit: 'Die Zahlung konnte nicht initialisiert werden. Bitte versuche es erneut.',
    errorGeneric: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    retry: 'Erneut versuchen',
  },

  footer: {
    tagline: 'PERFEKTE SKI - GANZ BEQUEM',
    serviceTitle: 'SKI-SERVICE',
    serviceJunior: 'Junior Service',
    serviceKleiner: 'Standard Service',
    serviceGrosser: 'Pro Service',
    serviceRenn: 'Renn-Service',
    legalTitle: 'RECHTLICHES',
    legalTerms: 'AGB',
    legalPrivacy: 'Datenschutz',
    legalImprint: 'Impressum',
    contactTitle: 'KONTAKT',
    newsletterTitle: 'UPDATES ERHALTEN',
    newsletterDescription: 'Erhalte exklusive Angebote und News direkt in dein Postfach.',
    newsletterPlaceholder: 'Deine E-Mail',
    feedbackTitle: 'DEIN FEEDBACK',
    feedbackDescription: 'Wie war dein Erlebnis mit dem Ski-Service Kurier? Wir freuen uns über deine Rückmeldung.',
    feedbackPlaceholder: 'Dein Kommentar (optional)...',
    feedbackSubmit: 'ABSENDEN',
    feedbackSubmitting: 'WIRD GESENDET...',
    feedbackSuccess: 'Danke für dein Feedback! 🎿',
    feedbackRating1: 'Schlecht',
    feedbackRating2: 'Ausbaufähig',
    feedbackRating3: 'Ok',
    feedbackRating4: 'Gut',
    feedbackRating5: 'Ausgezeichnet',
    copyright: '© {{year}} Ski-Service Kurier. Alle Rechte vorbehalten.',
    poweredBy: 'Powered by Readdy',
    watermark: 'SKI SERVICE KURIER',
  },

  feedback: {
    headline: 'WIE WAR DEIN ERLEBNIS?',
  },

  common: {
    close: 'Schliessen',
    previousSection: 'Vorheriger Abschnitt',
    nextSection: 'Nächster Abschnitt',
    toSection: 'Zu Abschnitt',
  },

  imprint: {
    companyName: 'Service Kurier GmbH (in Gründung)',
    street: 'Talstrasse 57',
    city: '7250 Klosters',
    statusLabel: 'Gesellschaftsstatus',
    statusValue: 'Gesellschaft in Gründung',
    contactLabel: 'Kontakt',
  },

  terms: {
    title: 'Allgemeine Geschäftsbedingungen (AGB)',
    lastUpdated: 'Stand: Januar 2025',
    s1Title: '1. Geltungsbereich',
    s1Text: 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Leistungen der Service Kurier GmbH (in Gründung), Talstrasse 57, 7250 Klosters (nachfolgend «Anbieter»), gegenüber Kundinnen und Kunden (nachfolgend «Kunde»).',
    s2Title: '2. Leistungsbeschreibung',
    s2Text: 'Der Anbieter bietet einen Ski-Service-Kurierdienst an. Ski werden am Abend beim Kunden abgeholt, professionell gewartet und am nächsten Morgen bis spätestens {{returnTime}} Uhr zurückgebracht. Bestellungen müssen bis {{orderDeadline}} Uhr des gewünschten Abholtages aufgegeben werden.',
    s3Title: '3. Vertragsschluss',
    s3Text: 'Der Vertrag kommt mit der Buchungsbestätigung per E-Mail zustande. Der Kunde ist verpflichtet, korrekte Angaben zu machen. Falsche Angaben können zur Stornierung der Buchung führen.',
    s4Title: '4. Preise und Zahlung',
    s4Text: 'Alle Preise verstehen sich in Schweizer Franken (CHF) inkl. Mehrwertsteuer. Die Zahlung erfolgt online bei der Buchung. Akzeptierte Zahlungsmittel: Kreditkarte, TWINT, Apple Pay, PayPal.',
    s5Title: '5. Stornierung',
    s5Text: 'Stornierungen sind bis 12:00 Uhr des Abholtages kostenlos möglich. Bei späteren Stornierungen oder Nichterscheinen wird der volle Betrag in Rechnung gestellt. Stornierungen sind per E-Mail an klosters@ski-service-kurier.ch zu richten.',
    s6Title: '6. Haftung',
    s6Text: 'Der Anbieter haftet für Schäden an den Ski, die nachweislich während des Transports oder des Services entstanden sind. Die Haftung ist auf den Zeitwert des beschädigten Gegenstands begrenzt. Für Schäden durch höhere Gewalt wird keine Haftung übernommen.',
    s7Title: '7. Anwendbares Recht',
    s7Text: 'Es gilt Schweizer Recht. Gerichtsstand ist Klosters, Schweiz.',
  },

  privacy: {
    title: 'Datenschutzerklärung',
    lastUpdated: 'Stand: Januar 2025',
    s1Title: '1. Verantwortliche Stelle',
    s1Text: 'Verantwortlich für die Datenverarbeitung ist die Service Kurier GmbH (in Gründung), Talstrasse 57, 7250 Klosters, E-Mail: klosters@ski-service-kurier.ch.',
    s2Title: '2. Erhobene Daten',
    s2Text: 'Bei der Buchung erheben wir folgende Daten: Name, Adresse/Unterkunft, Telefonnummer, E-Mail-Adresse sowie Zahlungsinformationen. Diese Daten werden ausschliesslich zur Abwicklung des Auftrags verwendet.',
    s3Title: '3. Zweck der Verarbeitung',
    s3Text: 'Deine Daten werden verwendet für: Auftragsabwicklung und Kommunikation, Versand von Buchungsbestätigungen, Rechnungsstellung sowie zur Verbesserung unserer Dienstleistungen.',
    s4Title: '4. Marketing-E-Mails',
    s4Text: 'Mit deiner ausdrücklichen Einwilligung (Opt-in im Buchungsformular) verwenden wir deine E-Mail-Adresse, um dich über Aktionen, Rabatte und Neuigkeiten zu informieren. Diese Einwilligung ist freiwillig und kann jederzeit ohne Angabe von Gründen widerrufen werden – per E-Mail an klosters@ski-service-kurier.ch oder über den Abmeldelink in jeder Marketing-E-Mail.',
    s5Title: '5. Weitergabe an Dritte',
    s5Text: 'Deine Daten werden nicht an Dritte verkauft. Eine Weitergabe erfolgt nur, soweit dies zur Vertragserfüllung notwendig ist (z. B. Zahlungsdienstleister) oder gesetzlich vorgeschrieben.',
    s6Title: '6. Datensicherheit',
    s6Text: 'Wir setzen technische und organisatorische Massnahmen ein, um deine Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen. Die Zahlungsabwicklung erfolgt verschlüsselt über zertifizierte Anbieter.',
    s7Title: '7. Speicherdauer',
    s7Text: 'Deine Daten werden nur so lange gespeichert, wie es für die Auftragsabwicklung notwendig ist oder gesetzliche Aufbewahrungspflichten bestehen (in der Regel 10 Jahre für Buchhaltungsunterlagen).',
    s8Title: '8. Deine Rechte',
    s8Text: 'Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner Daten. Anfragen richtest du bitte an: klosters@ski-service-kurier.ch.',
    s9Title: '9. Cookies',
    s9Text: 'Unsere Website verwendet technisch notwendige Cookies, um den Betrieb der Seite zu gewährleisten. Es werden keine Tracking- oder Werbe-Cookies eingesetzt.',
  },
};
